import { useEffect, useState } from 'react';
import { useScrollPosition } from '../hooks/useScrollPosition.js';
import './PageBubbles.css';
const PageBubbles = () => {

  const [activePage, setActivePage] = useState(1);


  const { x } = useScrollPosition();
    

  //console.log('scrollPosition', x, window.innerWidth);

  useEffect(() => {
    //
    const half = window.innerWidth / 2;
    if (x < half) {
      setActivePage(1);
    } else if (x >= half && x <= window.innerWidth + half) {
      setActivePage(2);
    } else if (x >= window.innerWidth + half) {
      setActivePage(3);
    }
    return () => {

    };
  }, [x]);

  const onClickPageBubble = (event) => {
    const full = window.innerWidth;
    //const half = window.innerWidth / 2;
    const el = document.querySelector('.scrollx');
    console.log('onClickPageBubble event', event.target);
    console.log('onClickPageBubble event', event.target.getAttribute('data-number'));
    const pageNumber = parseInt(event.target.getAttribute('data-number'));
    //if (this.state.activePage !== pageNumber) {
      //this.setState({ activePage: pageNumber });
      //this.goToPage(pageNumber);
      console.log('going to ', pageNumber);
      el.scroll({
        left: full * (pageNumber - 1),
        behavior: 'smooth'
      });
    //}
  };

  const onClickPrev = e => {
    const full = window.innerWidth;
    //const half = window.innerWidth / 2;
    const el = document.querySelector('.scrollx');
    if (el.scrollLeft > 0) {
      if (el.scrollLeft - full > 0) {
        //el.scrollLeft = el.scrollLeft - full;
        el.scroll({
          left: el.scrollLeft - full,
          behavior: 'smooth'
        });
      } else {
        el.scrollLeft = 0;
      }
    }
  };

  const onClickNext = e => {
    const full = window.innerWidth;
    const half = window.innerWidth / 2;
    const el = document.querySelector('.scrollx');
    if (el.scrollLeft < full + half) {
      //el.scrollLeft = el.scrollLeft + full;
      el.scroll({
        left: el.scrollLeft + full,
        behavior: 'smooth'
      });
    }
  };

  const pageBubbles = [1, 2, 3].map((o, i) => {
    return <span key={i} data-number={i+1} onClick={onClickPageBubble} className={i+1 === activePage ? 'page-bubble page-bubble-active' : 'page-bubble'}></span>
  });

  return (
    <div className="page-bubbles">
      <span onClick={onClickPrev} className="page-bubbles-click-area page-bubbles-click-area-left"></span>
      {pageBubbles}
      <span onClick={onClickNext} className="page-bubbles-click-area page-bubbles-click-area-right"></span>
    </div>
  );

};
export default PageBubbles;